import React from 'react';

	const Logo = ({ width, height, showText = true, className = '', onClick }) => {
	// Default sizes based on showText
	const logoWidth = width || (showText ? 40 : 40);
	const logoHeight = height || (showText ? 40 : 40);
	const textSize = showText ? 'text-2xl' : 'text-lg';

	return (
		<div 
			className={`flex items-center space-x-3 ${className} ${onClick ? 'cursor-pointer' : ''}`}
			onClick={onClick}
		>
			<div
				className="flex-shrink-0 overflow-hidden rounded-full bg-transparent"
				style={{ width: logoWidth, height: logoHeight }}
			>
				<img
					src="/logo.png"
					alt="iVault Logo"
					width={logoWidth}
					height={logoHeight}
					className="block w-full h-full object-cover object-center"
				/>
			</div>
			{showText && (
				<span className={`font-bold text-gray-900 ${textSize} leading-tight`}>
					iVault
				</span>
			)}
		</div>
	);
};

export default Logo;



